import React from 'react';
import { Dropdown, Button, Menu } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import { exportToXLSX} from './ExportUtils'; // Fonctions pour l'export
import { printpdf } from '../Services/PrintService';

const ExportDropdown = ({ tableData }) => {
  const handleExport = (type) => {
    if (type === 'xlsx') {
      exportToXLSX(tableData);
    } else if (type === 'pdf') {
     printpdf('/Print/Exports/Tab/List_Documents_Dash')
    }
  };

  const menu = (
    <Menu onClick={(e) => handleExport(e.key)}>
      <Menu.Item key="xlsx">Export Excel</Menu.Item>
      <Menu.Item key="pdf">Export PDF</Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} placement="bottomCenter">
      <Button className='buttonExport' size="small" style={{marginTop:"8px"}} icon={<ExportOutlined />}>Export</Button>
    </Dropdown>
  );
};

export default ExportDropdown;
